import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSnackbar } from '#hooks';
import services from '#services';
import { actions } from '#store';

const useAreas = () => {
  const { enqueueErrorSnackbar } = useSnackbar();
  const state = useSelector(prop('areas'));
  const dispatch = useDispatch();

  const fetch = useCallback(async (query, { enableSnackbar } = {}) => {
    try {
      dispatch(actions.areas.fetch.creator());
      const areas = await services.bob.areas.getAll(query);
      dispatch(actions.areas.fetchSuccess.creator({ payload: areas }));
      return areas;
    } catch (err) {
      dispatch(actions.areas.fetchError.creator({ error: err.message }));
      if (enableSnackbar) {
        enqueueErrorSnackbar(err.message, {
          persist: true,
          buttons: [{
            text   : 'retry',
            onClick: () => fetch(query, { enableSnackbar }),
          }],
        });
        return null;
      }
      throw err;
    }
  }, [dispatch]);

  return {
    ...state,
    handlers: {
      fetch,
    },
  };
};

export default useAreas;
